import { inject, InjectionKey } from 'vue';
import { User } from './authenticator';

export const GetUserInjectionKey = Symbol('getUser') as InjectionKey<() => Promise<User>>;

export function useUserService() {
  const getUser = inject(GetUserInjectionKey) || (() => Promise.reject('Not implemented'));

  return {
    getUser
  };
}
